module.exports = __webpack_public_path__ + "img/analytics-marketing-team-3.65d58cbe.svg";